export default __webpack_public_path__ + "static/labelmap-7a8f9eb0296f2db3b18cbc3e1ae92211.gif";